import React from "react";
import { Table } from "reactstrap";
import { SimpleRow } from "../../../../layout/Table/SimpleRow";
import { TRANSLATED_API_KEY_STATUSES, TRANSLATED_ARCHIVE_SERVICE_STATUSES, TRANSLATED_ORGANIZATION_STATUSES, USER_STATUSES } from "../../../../../config/constants";
import { FormattedMessage } from "react-intl";
import { ROUTE_CLIENT_USER_VIEW } from "../../../../../config/routes";
import { LinkResource } from "../../../../../components/shared/LinkResource";
import { displayUsername } from "../../../../../helpers/displayUsername";

function OrganizationDetailsTable(props) {
  const { organization } = props;

  if (! organization?.id ) {
    return <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="messages.no_data" value=""/>
      </tbody>
    </Table>
  }

  return (
    <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.id"value={organization.id}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.name" value={organization.name}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.neo_id" value={organization.neo_id}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.cui" value={organization.cui}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.registry_no" value={organization.registry_no}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.user_id" value="test">
        {
          organization.owner?.id && organization.owner?.status === USER_STATUSES.ACTIVE ? 
          <LinkResource
            displayText={displayUsername(organization.owner)}
            resourceLink={ROUTE_CLIENT_USER_VIEW}
            resourceParamId={{':userId': organization.owner.id}}
          /> :
          <FormattedMessage id="components.pages.organizations.table.tableRow.user_deleted" />
        }
      </SimpleRow>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.phone" value={organization.phone}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.city" value={organization.city}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.county" value={organization.county}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.country" value={organization.country}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.status" value={TRANSLATED_ORGANIZATION_STATUSES[organization.status]}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.api_key_status" value={TRANSLATED_API_KEY_STATUSES[organization.api_key_status]}/>
      <SimpleRow translationKey="components.pages.organizations.organizationsTable.table.archive_service_settings" value={TRANSLATED_ARCHIVE_SERVICE_STATUSES[organization.archive_service_setting?.status]}/>
      </tbody>
    </Table>
  );
}

export { OrganizationDetailsTable };
